// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocalDateFormat } from 'src/app/_interfaces/data/local-data-format-model';
import { Settings } from 'src/app/_interfaces/settings-model';
import { SystemDetailsModel } from 'src/app/api/remote-api/.portal.generated/models';
import { SystemOverviewService } from '../../portal/services/systemOverview.service';
import { UserService } from '../../portal/services/user.service';
import { SettingsService } from '../services/settings.service';

export type ProcessPlaceholdersParams = Partial<
  SystemDetailsModel & {
    dateFormat: string;
  }
>;

@Pipe({
  name: 'processPlaceholders',
  pure: false,
  standalone: true,
})
export class ProcessPlaceholdersPipe implements PipeTransform {
  systemDetails: SystemDetailsModel | undefined;
  settings: Settings | undefined;
  dateFormat: LocalDateFormat | undefined;
  idToken: string | undefined;

  constructor(
    systemOverviewService: SystemOverviewService,
    settingsService: SettingsService,
    userService: UserService
  ) {
    systemOverviewService.systemDetails.lastSuccessfulData$
      .pipe(takeUntilDestroyed())
      .subscribe((systemDetails) => {
        this.systemDetails = systemDetails;
      });
    settingsService.settings$
      .pipe(takeUntilDestroyed())
      .subscribe((settings) => {
        this.settings = settings;
      });
    settingsService.dateFormat$
      .pipe(takeUntilDestroyed())
      .subscribe((dateFormat) => {
        this.dateFormat = dateFormat;
      });

    this.idToken = userService.getIdToken();
  }

  /**
   *
   * @param- v
   */
  transform(url: string, params: ProcessPlaceholdersParams = {}): string {
    const merged = {
      ...{
        dateFormat: this.dateFormat?.longFormat,
        idToken: this.idToken,
      },
      ...this.systemDetails,
      ...params,
    };
    return processSystemPlaceholders(url, merged as ProcessPlaceholdersParams);
  }
}

/**
 * replaces systemSerialNumber and systemMaterialNumber in case systemDetails are given
 */
export function processSystemPlaceholders(
  url: string,
  params?: ProcessPlaceholdersParams
): string {
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (key) {
        url = url.replace(new RegExp(`{${key}}`, 'g'), String(value));
      }
    });
  }
  return url;
}
